import { createRoutine } from 'redux-saga-routines';
import { LOCATION_LIST, LOCATION_RETRIEVE } from './type';

export const locationList = createRoutine(LOCATION_LIST);
export const locationRetrieve = createRoutine(LOCATION_RETRIEVE);
